"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.screenMin = exports.screenMax = exports.screen = void 0;
var _styledComponents = require("styled-components");
var _layout = require("../../tokens/layout");
const mediaQuery = media => function (first) {
  for (var _len = arguments.length, interpolations = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    interpolations[_key - 1] = arguments[_key];
  }
  return (0, _styledComponents.css)(["@media ", "{", ";}"], media, (0, _styledComponents.css)(first, ...interpolations));
};
const screenMin = exports.screenMin = {
  s: mediaQuery(`(min-width: ${_layout.BREAKPOINT.XS}px)`),
  m: mediaQuery(`(min-width: ${_layout.BREAKPOINT.S}px)`),
  l: mediaQuery(`(min-width: ${_layout.BREAKPOINT.M}px)`),
  xl: mediaQuery(`(min-width: ${_layout.BREAKPOINT.L}px)`)
};
const screenMax = exports.screenMax = {
  xs: mediaQuery(`(max-width: ${_layout.BREAKPOINT.XS - 1}px)`),
  s: mediaQuery(`(max-width: ${_layout.BREAKPOINT.S - 1}px)`),
  m: mediaQuery(`(max-width: ${_layout.BREAKPOINT.M - 1}px)`),
  l: mediaQuery(`(max-width: ${_layout.BREAKPOINT.L - 1}px)`)
};
const screen = exports.screen = {
  xs: mediaQuery(`(max-width: ${_layout.BREAKPOINT.XS - 1}px)`),
  s: mediaQuery(`(min-width: ${_layout.BREAKPOINT.XS}px) and (max-width: ${_layout.BREAKPOINT.S - 1}px)`),
  m: mediaQuery(`(min-width: ${_layout.BREAKPOINT.S}px) and (max-width: ${_layout.BREAKPOINT.M - 1}px)`),
  l: mediaQuery(`(min-width: ${_layout.BREAKPOINT.M}px) and (max-width: ${_layout.BREAKPOINT.L - 1}px)`),
  xl: mediaQuery(`(min-width: ${_layout.BREAKPOINT.L}px)`)
};